import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TagInputModule } from "ngx-chips";
import { CommonTLFModule } from '../../common/common.module';
import { FormAccessoagliattiComponent } from "./form-accessoagliatti/form-accessoagliatti.component";
import { FormAccessoagliattiViewComponent } from "./form-accessoagliatti/view/form-accessoagliatti-view.component";
import {
  FormAltrerisoluzionilavoroComponent
} from "./form-altrerisoluzionilavoro/form-altrerisoluzionilavoro.component";
import {
  FormAltrerisoluzionilavoroViewComponent
} from "./form-altrerisoluzionilavoro/view/form-altrerisoluzionilavoro-view.component";
import { FormDisciplinaComponent } from "./form-disciplina/form-disciplina.component";
import { FormDisciplinaViewComponent } from "./form-disciplina/view/form-disciplina-view.component";
import {
  FormOpposaiserviziispettiviComponent
} from "./form-opposaiserviziispettivi/form-opposaiserviziispettivi.component";
import {
  FormOpposaiserviziispettiviViewComponent
} from "./form-opposaiserviziispettivi/view/form-opposaiserviziispettivi-view.component";
import { FormParereComponent } from "./form-parere/form-parere.component";
import { FormParereViewComponent } from "./form-parere/view/form-parere-view.component";
import { DynamicComponentService } from "./services/dynamic-component.service";
import { FormConsulenzaComponent } from './form-consulenza/form-consulenza.component';
import { FormConsulenzaViewComponent } from './form-consulenza/view/form-consulenza-view.component';
import { FormGestioneAmministrativaComponent } from './form-gestione-amministrativa/form-gestione-amministrativa.component';
import { FormGestioneAmministrativaViewComponent } from './form-gestione-amministrativa/view/form-gestione-amministrativa-view.component';
import { FormGenericoComponent } from './form-generico/form-generico.component';
import { FormGenericoViewComponent } from './form-generico/view/form-generico-view.component';


@NgModule({
    imports: [CommonTLFModule, CommonModule, RouterModule, NgbModule, FormsModule, ReactiveFormsModule, TagInputModule, NgSelectModule],
    declarations: [
        FormParereComponent,
        FormParereViewComponent,
        FormConsulenzaComponent,
        FormConsulenzaViewComponent,
        FormGestioneAmministrativaComponent,
        FormGestioneAmministrativaViewComponent,
        FormDisciplinaComponent,
        FormDisciplinaViewComponent,
        FormAltrerisoluzionilavoroComponent,
        FormAltrerisoluzionilavoroViewComponent,
        FormAccessoagliattiComponent,
        FormAccessoagliattiViewComponent,
        FormOpposaiserviziispettiviComponent,
        FormOpposaiserviziispettiviViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
    ],
    providers: [DynamicComponentService],
    exports: [
        FormParereComponent,
        FormParereViewComponent,
        FormDisciplinaComponent,
        FormDisciplinaViewComponent,
        FormAltrerisoluzionilavoroComponent,
        FormAltrerisoluzionilavoroViewComponent,
        FormAccessoagliattiComponent,
        FormAccessoagliattiViewComponent,
        FormOpposaiserviziispettiviComponent,
        FormOpposaiserviziispettiviViewComponent,
        FormConsulenzaComponent,
        FormConsulenzaViewComponent,
        FormGestioneAmministrativaComponent,
        FormGestioneAmministrativaViewComponent,
        FormGenericoComponent,
        FormGenericoViewComponent,
    ]
})
export class FascicoloFormSharedModule {

}
